import { createAction } from "@reduxjs/toolkit";

export const updateHasAnyChange = createAction<boolean>(
  "[QuestionnaireProcess] Update Has Any Change"
);
export const updateSaveAndCompleteOrder = createAction<boolean>(
  "[QuestionnaireProcess] Update Save And Complete Order"
);
export const setIsSubmittedQuestionnaire = createAction<boolean>(
  "[QuestionnaireProcess] Update Is Submitted Questionnaire"
);
